import React, { useRef, useState } from "react";
import { Box, Typography } from "@mui/material";

const containsFiles = (event) =>
  Array.from(event?.dataTransfer?.types || []).includes("Files");

// WhatsApp style drop zone : wraps an area, shows a full overlay while a
// file is dragged over it and hands the dropped files to the parent.
const FileDropZone = ({
  children,
  onFilesDropped,
  disabled = false,
  overlayText = "Drop files here",
  overlaySubText = "Attach up to 5 files",
  style,
}) => {
  const [isDragActive, setDragActive] = useState(false);
  const dragCounter = useRef(0);

  const handleDragEnter = (e) => {
    if (disabled || !containsFiles(e)) return;
    e.preventDefault();
    e.stopPropagation();
    dragCounter.current += 1;
    setDragActive(true);
  };

  const handleDragOver = (e) => {
    if (disabled || !containsFiles(e)) return;
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = "copy";
  };

  const handleDragLeave = (e) => {
    if (disabled || !containsFiles(e)) return;
    e.preventDefault();
    e.stopPropagation();
    dragCounter.current -= 1;
    if (dragCounter.current <= 0) {
      dragCounter.current = 0;
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    if (disabled || !containsFiles(e)) return;
    e.preventDefault();
    e.stopPropagation();
    dragCounter.current = 0;
    setDragActive(false);
    const files = Array.from(e.dataTransfer?.files || []);
    if (files.length > 0) {
      onFilesDropped(files);
    }
  };

  return (
    <Box
      position="relative"
      style={style}
      onDragEnter={handleDragEnter}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      {children}
      {isDragActive && (
        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          zIndex={1300}
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{
            backgroundColor: "rgba(255, 255, 255, 0.93)",
            pointerEvents: "none",
          }}
        >
          <Box
            sx={{
              border: "2px dashed #DB0011",
              borderRadius: "0.5rem",
              padding: "2rem 3rem",
              textAlign: "center",
            }}
          >
            <Typography fontWeight={600} fontSize="1rem">
              {overlayText}
            </Typography>
            <Typography fontSize="0.75rem" color="#8C8C8C" mt="0.3rem">
              {overlaySubText}
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default FileDropZone;
